<template>
  <div>
      <div class="choice" :style="{height:fullpage + 'px'}"> 
          <div class="choice-c">
            <router-link :to="'/video?cateid='+this.cate">
               <img src="../../assets/videobtn.png" alt="">
            </router-link>
            <router-link :to='{path:"/teach",query:{cateid:this.cate}}'>
                <img src="../../assets/wordbtn.png" alt="">
            </router-link>  
          </div>
      </div>
  </div>
</template>
<script>
    export default{
        props: {
            cate: {
                type: String,
                required: true,
            },
        },
        data(){
            return{
              fullpage:document.documentElement.clientHeight,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/mobile/tation/ContentCategory.vue